import {IconMapping} from 'schemas/schema-interface/v2/getSchemaInterfaceIcon';

import {AntibodyComponentSchemaInterfaceApiId} from './AntibodySchemaInterfaceConstants';
import {ANTIBODY_SCHEMA_INTERFACE_ID} from './AntibodySchemaInterfaceConstants';

export const ANTIBODY_INTERFACE_ICON_MAPPING: IconMapping = {
  [ANTIBODY_SCHEMA_INTERFACE_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.AA_CHAIN_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.AA_DOMAIN_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.AA_PAIR_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.DNA_CHAIN_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.DNA_DOMAIN_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.DNA_SUB_ELEMENT_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.DNA_PAIR_ID]: 'antibody',
  [AntibodyComponentSchemaInterfaceApiId.ANTIGEN_ID]: 'antibody',
};
